<template>
  <Spinner v-if="loading" class="my-5">{{ loadingMessage || "Loading ..." }}</Spinner>
</template>
<script>
import Spinner from './includes/Spinner.vue'
import axios from 'axios';
// const source = axios.CancelToken.source();
/* eslint-disable */
export default {
  components: {
    Spinner
  },
  name: 'RedirectQuery',
  props: ['data', 'client_info'],

  computed: {
    item() {
      return this.data.details;
    }
  },
  data() {
    return {
      loading: true,
      loadingMessage: 'Please wait.. Verifying transaction',
      provider: null,
      type: '',
      retry_count: 0,
    }
  },
  mounted() {
    this.provider = this.data.details.iframereply.provider;
    this.treatProviders(this.provider.provider.toLowerCase());
  },
  methods: {
    changePaymentOption() {
      this.$parent.changeComponent("PaymentOptions");
    },

    isIpg(replyData) {
      this.type = "ipg"
      if (replyData.data.txnref != "") // you can get this form the transaction itself
        this.queryTransaction(replyData.data.txnref, this.provider);
      else {
        this.loading = false;
        window.failedFromStart = false;
        window.failedFromStartMessage = replyData.data.desc;
        let raw = JSON.parse(window.raw)
        raw.message = replyData.data.desc
        window.raw = JSON.stringify(raw);
        this.$router.push('/v2/warning');
      }
    },

    isPaystack(replyData) {
      this.type = "paystack"
      if (replyData.data.reference != "undefined" || replyData.data.reference != null) {
        this.pushPaystackToOnepipe()
      } else {
        this.loading = false;
        window.failedFromStart = false;
        window.failedFromStartMessage =
          "Paystack payment reference is missing. On your console, ensure your callback_url has a get parameter like this <strong>?provider=paystack</strong>";
        let raw = JSON.parse(window.raw)
        raw.message = replyData.data.desc
        window.raw = JSON.stringify(raw);
        this.$router.push('/v2/warning');
      }
    },
    treatProviders(providerName) {

      if (providerName == "masterpass") {
        this.type = "masterpass"
        this.loadingMessage = 'Checking Masterpass for your cards ..'
        this.getMpassCard();
        return;
      }

      this.loadingMessage = 'Validating payment ..';
      let replyData = this.data.details.iframereply;

      if (['paystack', 'paystackv2'].includes(providerName)) {
        return this.isPaystack(replyData);
      }

      this.type = providerName;
      if (providerName == "ipg") {
        return this.isIpg(replyData);
      }

      if (['opay', 'stripe', 'gbp', 'gocardless', 'rhemitocardservice', 'hydrogenpay', 'habaripay', 'rhemitoaccount', 'rhemitoaccountv2', 'payceler', 'fidelitympgs'].includes(providerName)) {
        return this.queryTransaction(providerName);
      }
    },

    handleResponse(data, reference) {
      let hash = data.data,
        res = this.$decodeToken(hash),
        status = res.status.toLowerCase(),
        message = res.message,
        responseData = res.data;
      window.raw = JSON.stringify(res);
      this.loading = false;

      if (status === "successful") {
        return this.$parent.changeComponent('Status', {
          reference,
          type: 'Successful',
          message: message || res.data.message,
          data: responseData,
        });
      } else if (['pendingfulfilment', 'processing', 'pendingvalidation'].includes(status)) {
        return this.$parent.changeComponent('Status', {
          reference,
          type: status,
          message: message || res.data.message,
          data: responseData,
        });
      }

      if (Object.key(res).includes(retry) && res.retry == true) {
        if (this.retry_count <= 2) {
          setTimeout(() => {
            this.retryQuery();
          }, 3000);
        }
        return this.$parent.changeComponent('Status', {
          reference,
          type: 'Processing',
          message: 'Transaction Processing',
          data: responseData ? responseData : {},
        });
      } else {
        window.failedFromStart = false;
        window.failedFromStartMessage = message;
        this.$router.push('/v2/warning');
      }
    },

    getPayload(payload) {
      let newPayload,
        randomId = this.$generateRequestRef();
      if (this.provider.provider.toLowerCase() !== 'paystack') {
        newPayload = {
          request_ref: randomId,
          request_type: payload.request_type,
          auth: {
            type: 'card',
            secure: this.$store.state.transRef, //  IPG trxn ref
            auth_provider: this.provider.provider
          },
          transaction: {
            transaction_ref: this.$store.state.transRef,
          }
        }
      } else {

        newPayload = {
          request_ref: randomId,
          request_type: payload.request_type,
          auth: {
            type: 'custom',
            secure: this.$store.state.transRef, //  IPG trxn ref
            auth_provider: this.provider.provider
          },
          transaction: payload.transaction
        }
        newPayload.transaction.transaction_ref = this.$store.state.transRef

      }

      if (this.$store.state.isFailed)
        newPayload.transaction.transaction_ref_parent = this.$store.state.parentTransRef

      return newPayload;
    },

    pushPaystackToOnepipe() {
      let api_key = this.$store.state.api_key,
        data2 = {
          api_key,
          endpoint: this.provider.provider.toLowerCase() == 'paystackv2' ? 'query' : 'transact',
          payload: this.getPayload(this.$store.state.payload),
        },
        dataPayload = this.$generateToken(data2);

      axios.post(this.baseApiUrl + "v2/onepipe/js", {
        data: dataPayload,
      }, {
        timeout: this.API_CALL_TIMEOUT, // 3 mins
        headers: {
          Authorization: `Bearer ${api_key}`
        }
      }).then(({
        data
      }) => {
        return this.handleResponse(data, data2.payload.transaction.transaction_ref);
      })
        .catch(error => {
          window.failedFromStartMessage = error;
          window.failedFromStart = false;
          this.$router.push('/v2/warning');
        })
    },

    queryTransaction(provider = 'ipg') {
      let intialPayload = this.$store.state.payload,
        payload = {
          request_ref: this.$generateRequestRef(),
          request_type: intialPayload.request_type,
          auth: {
            type: 'custom',
            secure: this.$store.state.transRef, //  IPG trxn ref
            auth_provider: provider
          },
          transaction: {
            transaction_ref: this.$store.state.transRef,
          }
        },
        data2 = {
          api_key: this.$store.state.api_key,
          endpoint: 'query',
          payload
        },
        dataPayload = this.$generateToken(data2);

      if (this.$store.state.isFailed) {
        payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef
      }

      axios.post(this.baseApiUrl + "v2/onepipe/js", {
        data: dataPayload,
      }, {
        timeout: this.API_CALL_TIMEOUT, // 3 mins
        headers: {
          Authorization: `Bearer ${this.$store.state.payload.api_key}`
        }
      }).then(({
        data
      }) => {
        return this.handleResponse(data, data2.payload.transaction.transaction_ref);
      })
        .catch(error => {
          window.failedFromStartMessage = error;
          window.failedFromStart = false;
          this.$router.push('/v2/warning');
        })
    },

    retryQuery() {
      this.retry_count = this.retry_count + 1;
      switch (this.type) {
        case 'paystack':
          this.pushPaystackToOnepipe();
          break;

        default:
          this.queryTransaction();
          break
      }
    }
  },
}
</script>
